import React from 'react'
import OrderCreateContainer from 'containers/panel/subreseller/order-create-container'
const OrderCreatePage = () => {
  return (
    <OrderCreateContainer/>
  )
}

export default OrderCreatePage